import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
} from '@tanstack/react-router'

import { HomePage } from "./Pages/HomePage"
import { Quotes } from "./Pages/Quotes"
import { Anime } from "./Pages/Anime"
import { TaskDetails, Tasks } from './Pages/Tasks'
import { Daily } from './Pages/Daily'
import { WebAudioLab } from './Pages/WebAudioLab'
import { Calendar } from './Pages/Calendar'
import { UserSettings } from './Components/UserSettings'

// Root layout (like App.razor / _Layout.cshtml)
const rootRoute = createRootRoute({
  component: () => (
    <div>
      <UserSettings />
      <Outlet /> 
    </div>
  ),
})

  // Index route "/"
  const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: HomePage,
  })
  
  const quotesRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/quotes',
    component: Quotes,
  })

  const animeRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/anime',
    component: Anime,
  })

  const tasksRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/tasks',
    component: Tasks,
  })

  const taskDetailsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/tasks/$taskId',
    component: TaskDetails,
  })

  const dailyRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/daily',
    component: Daily,
  })

  const audioRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/audio',
    component: WebAudioLab,
  })

   const calendarRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/calendar',
    component: Calendar,
  })
  
// Build tree
const routeTree = rootRoute.addChildren([
    indexRoute,
    quotesRoute,
    animeRoute,
    tasksRoute,
    taskDetailsRoute,
    dailyRoute,
    audioRoute,
    calendarRoute,
])

// Create router
export const router = createRouter({
    routeTree,
})
